import orderItem from '@/modules/user-info/components/order-item/index.vue'
import {mapActions, mapGetters} from "vuex";

export default {
    name: 'order',
    data: {
        return: {}
    },
    components: {
        orderItem
    },
    created() {
        this.getHistory()
    },
    computed: {
        ...mapGetters({
            historyOrders: 'order/historyOrders'
        })
    },
    methods: {
        ...mapActions({
            getHistory: 'order/HISTORY_ORDERS'
        }),
    },

}
